document.addEventListener('DOMContentLoaded', function(){
    var devMenuContainer = document.querySelector('.dev-menu-container');
    var devSearchContainer = document.querySelector('.dev-search-container');
    var devSearch = document.querySelector('.site-nav-search-icon');
    var bottomBar = document.querySelector('.dev-header-bottom');
    var searchIconLink = document.querySelector('a.site-nav-search-icon:not(.globo-search-activator)');
  var noTransition = document.querySelector('.no-transition');
   var inputElements = document.querySelectorAll('input.search-input');
  var header = document.querySelector('#header');
  
    // Function handling scrolling  
  var stopScroll = false;

    window.onscroll = function() {

      
        if(stopScroll) return; 

    // Any active inputs lose focus.
     if(document.activeElement.tagName === 'INPUT' && document.activeElement.classList.contains('header-search-input-dev')){
    document.activeElement.blur();
}

    if(window.pageYOffset > 0) {
        devMenuContainer.classList.add('scrolling');
        devSearchContainer.classList.add('hidding');
    header.classList.remove('not-sticky');

 bottomBar.classList.remove('appear');
      header.classList.remove('sticky-bottom');
      
        for(let i=0; i<inputElements.length; i++){
            inputElements[i].value = '';
        }


       
       
    } else {
        
     
            bottomBar.classList.add('appear');
            devMenuContainer.classList.remove('scrolling');
            devSearchContainer.classList.remove('hidding');
    header.classList.add('not-sticky');
     
       if (window.devTemplate == 'index') {
       bottomBar.classList.remove('appear');
       }
    }
}     
    // Function handling click event on the search icon link
    searchIconLink.addEventListener('click', function(e){
        e.stopPropagation(); 
        e.preventDefault();
      
   
        devMenuContainer.classList.remove('scrolling');
        bottomBar.classList.add('appear');
        devSearchContainer.classList.remove('hidding');
     
      header.classList.add('sticky-bottom');

    });
  




});

